/** @jsx jsx */
import { jsx } from "theme-ui";
import Container from "../container";
import LinkResolve from "./linkResolve";
import PortableTextComponent from "./portableTextComponents";
import { PortableText } from "@portabletext/react";

const TextModule = ({ value }) => {
  return (
    <div
      id={value?.id?.current ? value?.id?.current : ""}
      sx={{
        background: value?.background == "white" ? "white" : "grayBG",
        paddingTop: "75px",
        paddingBottom: "75px",
      }}
    >
      <Container>
        {value.headline && (
          <h2
            sx={{
              fontSize: "3rem",
              marginBottom: "0",
              marginTop: "0",
              width: "100%",
              textAlign: "center",
            }}
          >
            {value.headline}
          </h2>
        )}
        {value.text &&
          <div
          sx={{
            textAlign:"center",
            color:"textGray",
            fontSize:'1.2rem',
            marginTop:"20px",
            p:{
              margin:"0px 0px 20px 0px",
              padding:"0px",
            },
            "p:last-child":{
              marginBottom:"0px",
            }
          }}
          >
            <PortableText value={value.text} components={PortableTextComponent} />
          </div>
        
        }
        {value.link && (
          <div
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop:"30px",
              a: {
                variant: "buttons.primaryBlue",
                marginTop: "0px",
                display: "inline-block",
              },
            }}
          >
            <LinkResolve
              link={value.link.link}
              children={value.link.label}
              target="_blank"
              ariaLabel={value.link?.arialLabel}
            />
          </div>
        )}
      </Container>
    </div>
  );
};

export default TextModule;
